<div class="component-main-container">
  <!-- Header do componente -->
  <app-page-header parentTitle="{{ 'parameters.parameters-parent-label' | translate }}"
    pageTitle="{{ 'parameters.parameters-title-label' | translate }}"></app-page-header>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <!-- criar parâmetros-->
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <div class="form-fields-box" [ngClass]="!isCreateParamOpen ? 'closed' : ''">
          <h2 (click)="openCloseCreateParam()">
            {{ "parameters.form-register-label" | translate }}
          </h2>
          <hr [ngClass]="!isCreateParamOpen ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "parameters.form-register-reference" | translate
                }}</mat-label>
              <input [formControl]="referenceCreateForm" matInput type="text" />
            </mat-form-field>
          </div>
          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "parameters.form-register-parameters" | translate
                }}</mat-label>
              <input [formControl]="paramCreateForm" matInput type="text" />
            </mat-form-field>
          </div>
          @if (!loadingCreateParameters) {
          <button class="btn btn-success mb-2 w-100" (click)="createParameters()" [disabled]="
              referenceCreateForm.value === null ||
              this.paramCreateForm.value === null
            ">
            {{ "parameters.form-button-save" | translate }}
          </button>
          }
          @if (loadingCreateParameters) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <!-- Filtrar parâmetros-->
        <div class="form-fields-box" [ngClass]="!isFilterOpen ? 'closed' : ''">
          <h2 (click)="openCloseFilterParam()">
            {{ "parameters.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!isFilterOpen ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "parameters.form-filter-reference" | translate
                }}</mat-label>
              <input [formControl]="referenceFilterForm" matInput type="text" />
            </mat-form-field>
          </div>
          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "parameters.form-filter-parameters" | translate
                }}</mat-label>
              <input [formControl]="parameterFilterForm" matInput type="text" />
            </mat-form-field>
          </div>

          @if (!loadingParameters) {
          <button class="btn btn-success " (click)="filterParameters(null)" [disabled]="filter">
            {{ "parameters.form-button-filter" | translate }}
          </button>
          }

          @if (loadingParameters) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Tabela parâmetros-->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3d">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference"> {{ "parameters.column-reference" | translate }}
              <th pSortableColumn="parameter"> {{ "parameters.column-parameters" | translate }}
              </th>
              <th pSortableColumn="actions">{{"parameters.column-actions" | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td> {{row.reference}}
              </td>
              <td> {{row.parameter}}
              </td>
              <td>
                <p-button (click)="OpenSidebarUpdate(row.id, row.reference, row.parameter, true)"
                  styleClass="btn-actions" [rounded]="true" icon="pi pi-pen-to-square" />

                <p-button (click)="OpenSidebarUpdate(row.id, row.reference, row.parameter, false)" styleClass="btn-view"
                  [rounded]="true" icon="pi pi-eye" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
  @if (editorController || viewController) {
  <div class="sidebar-edit" [formGroup]="updateForm">
    <mat-icon class="component-close-icon" (click)="closeEditionSidebar()">clear</mat-icon>
    @if (viewController) {
    <h2> {{"parameters.form-edit" | translate}} </h2>
    }
    @if (!viewController) {
    <h2> {{"parameters.form-view" | translate}} </h2>
    }
    <hr>
    <mat-form-field appearance="outline">
      <mat-label> {{"parameters.edit-reference" | translate}} </mat-label>
      <input matInput formControlName="reference">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label> {{"parameters.edit-parameter" | translate}} </mat-label>
      <input matInput formControlName="parameter">
    </mat-form-field>
    @if (viewController) {
    <button class="btn btn-success" (click)="updateParameter()"> {{"parameters.edit-button" |
      translate}} </button>
    }
  </div>
  }
</div>